import giftIcon from "@assets/icon-gift.svg";
import Button from "@components/AccessibleComponents/Button";
import { OKTAUserTypeEnum } from "@store/useOKTAUserStore";

import { LambdaResponsePayload } from "../../types/Alacrity";

export type ArticleSubshareProps = {
  testId?: string;
  isPremium: boolean;
  userType?: OKTAUserTypeEnum;
  handleGenerateGiftURLModal: () => void;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  alacrityRes?: LambdaResponsePayload;
};

export default function ArticleSubshare({
  isPremium = false,
  userType = OKTAUserTypeEnum.ANONYMOUS,
  handleGenerateGiftURLModal,
  setIsModalOpen,
  alacrityRes,
}: ArticleSubshareProps): React.ReactElement {
  const handleClick = () => {
    console.log("[subshare] alacrityRes", alacrityRes); //eslint-disable-line no-console

    if (alacrityRes) {
      setIsModalOpen(true);
    } else {
      handleGenerateGiftURLModal();
    }
  };

  return (
    <>
      {isPremium && userType === OKTAUserTypeEnum.SUBSCRIBER ? (
        <div data-testid="article-subshare-component">
          <Button
            onPress={handleClick}
            className="outline-none hover:opacity-70"
            aria-label="Gift this subscriber-only story to your friends and family"
          >
            <img
              src={giftIcon}
              width={40}
              height={40}
              alt="Share this article."
            />
          </Button>
        </div>
      ) : null}
    </>
  );
}
